import { render, staticRenderFns } from "./deliveryComponent.vue?vue&type=template&id=5a12e874"
import script from "./deliveryComponent.vue?vue&type=script&lang=js"
export * from "./deliveryComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports